/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import four04Style from './style';

export default function Four04() {
	let style = four04Style();

	return (
		<div style={style.outerStyle()}>
			<h1 className='mt-5 nice-header text-center px-3 text-black'>404 page not found</h1>
		</div>
	);
}
